import { Box } from "../../../../../../components";
import { useSearchParams } from "../../../../../../hook/use-search-params";
import { PermissionGrant } from "./PermissionGrant";
import { PermissionGroup } from "./PermissionGroup";

export const RightContent = () => {
  const { searchParams } = useSearchParams();
  const tab = searchParams.get("tab") || "1";

  return tab === "1" ? (
    <PermissionGrant />
  ) : (
    <Box
      title={tab === "1" ? "Thành viên" : "Thiết lập quyền"}
      style={{ borderRadius: 0, flex: 3, marginBottom: 0, marginLeft: "5px" }}
    >
      {" "}
      <PermissionGroup />{" "}
    </Box>
  );
};
